import {Injectable} from '@angular/core';
import {locale} from 'devextreme/localization';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import {OpcionMenu} from '@modelo/OpcionMenu.model';
import {PermisoPantalla} from '@modelo/PermisoPantalla.model';
import {FuncionesUsuarioEnum, TipoIconoEnum, TipoOpcionMenuEnum} from '@enumeraciones/Enumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {TipoOpcionEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {DialogoOpcion} from '@mensaje/Modelo/Dialogo.model';



@Injectable()
export class SistemaService {
    public usuario: any = {};

    public permisosCargados: boolean = false;
    public datosInicialesCargados: boolean = false;

    permisos: PermisoPantalla = new PermisoPantalla();
    pantallas: Array<any> = [];

    public idiomaSeleccionado: any;
    idiomas: Array<any> = [];
    parametros: Array<any> = [];

    public lenguajes: Array<string> = ["es"];
    public lenguajeDefault: string = "es";

    public localStoreVariable: any;

    public claseControlMd = "col-lg-4 col-md-4 col-sm-6 col-12";
    public claseControlLg = "col-lg-3 col-md-3 col-sm-6 col-12";

    //--- Expresiones Regulares ----
    NombrePersonalER = /^(([A-Z]|Ñ|[a-z]|[ñáéíóú]|[ÁÉÍÓÚ]){2,120}\s?)+$/;
    CorreoER = new RegExp("^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,3})$");
    PasswordER = new RegExp("^((?=.*\\d)(?=.*[secret-z])(?=.*[A-Z]).{6,20})$");
    PasswordTemporalER = new RegExp("^.{6,}$");
    TelefonoER = new RegExp("^[1-9][0-9]{2}[0-9]{3}[0-9]{4}$");
    TarjetaER = new RegExp("^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$");
    RFCMoralER = new RegExp("^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{3})\\d{2}((0[1-9]|1[012])(0[1-9]|1\\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\\w{2})([A|a|0-9]{1})$");
    RFCFisicaER = new RegExp("^(([ÑA-Z|ña-z|&amp;]{4}|[A-Z|a-z]{4})\\d{2}((0[1-9]|1[012])(0[1-9]|1\\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&amp;]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\\w{2})([A|a|0-9]{1})$");
    CURPER = new RegExp("^([A-Z&]|[a-z&]{1})([AEIOUX]|[aeioux]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([HM]|[hm]{1})([AS|as|BC|bc|BS|bs|CC|cc|CS|cs|CH|ch|CL|cl|CM|cm|DF|df|DG|dg|GT|gt|GR|gr|HG|hg|JC|jc|MC|mc|MN|mn|MS|ms|NT|nt|NL|nl|OC|oc|PL|pl|QT|qt|QR|qr|SP|sp|SL|sl|SR|sr|TC|tc|TS|ts|TL|tl|VZ|vz|YN|yn|ZS|zs|NE|ne]{2})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([A-Z&|a-z&|0-9]{2})$");
    //------ Mascaras -----------
    telefonoMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    tarjetaMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    //------ Animaciones ----------
    animacionAbirModal: string = "fadeInUp";
    animacionCerrarModal: string = "fadeOutUp";

    //mascara
    numeroEnteroMask = createNumberMask(
        {
            prefix: '',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: '',
            allowDecimal: false,
            decimalSymbol: '',
            decimalLimit: 0,
            integerLimit: null,
            requireDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: false
        });

        numeroEnteroConCeroMask = createNumberMask(
          {
              prefix: '',
              suffix: '',
              includeThousandsSeparator: true,
              thousandsSeparatorSymbol: '',
              allowDecimal: false,
              decimalSymbol: '',
              decimalLimit: 0,
              integerLimit: null,
              requireDecimal: false,
              allowNegative: false,
              allowLeadingZeroes: true
          });

    numeroDecimalMask = createNumberMask(
        {
            prefix: '',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: '',
            allowDecimal: true,
            decimalSymbol: '.',
            decimalLimit: null,
            integerLimit: null,
            requireDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: false
        });

    kfmaSK = createNumberMask(
        {
            prefix: 'KF',
            suffix: '',
            includeThousandsSeparator: false,
            thousandsSeparatorSymbol: '',
            allowDecimal: false,
            decimalSymbol: '',
            decimalLimit: 0,
            integerLimit: 3,
            requireDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: true
        });

    // tablas
    public tablaPaginacionModo = "compact";
    public tablaPaginacion = 10;
    public tablaPaginacionNavegacion = true;
    public tablaPaginacionInfo = true;
    public tablaPaginacionInfoText = 'Página {0} de {1} ({2} registros)';
    public tablaPaginacionSelector = true;
    public tablaPaginacionPaginaSize = [10, 25, 50, 0];

    //letiables
    public valorEnlace: number = 0;

    // Variables globales
    public opcionesMenu: Array<OpcionMenu> = [];
    public menuHome: Array<OpcionMenu> = [];
    public pathActivo: string = "";
    public NombrePantallaActual: string = "";
    public pantallaid: number = 0;

    public numeroControl: number = 0;

    private body = document.body;
    private html: HTMLElement = document.getElementById('html')!;

    constructor(private mensajeService: MensajeService, private translate: TranslateService, private datePipe: DatePipe) {
        this.GetValorActivo = this.GetValorActivo.bind(this);

        this.localStoreVariable =
        {
            Lenguaje: "Lenguaje",
            Paginacion: "Paginacion",
            JWT: "Secret",
            SideBarFijo: "SideBarFijo",
            LenguajeCambiado: "LenguajeCambiado",
            UsuarioEnmascarado: "UsuarioEnmascarado",
            SesionValida: "SesionValida",
            AOT: "AOT"
        };

        if (localStorage.getItem(this.localStoreVariable.Paginacion)) {
            this.tablaPaginacion = parseInt(localStorage.getItem(this.localStoreVariable.Paginacion) as string);
        }

        // idioma
        translate.addLangs(this.lenguajes);
        translate.setDefaultLang(this.lenguajeDefault);
        translate.use(this.lenguajeDefault);
        locale(this.lenguajeDefault);
    }

    // ------- Idioma -------
    CambiarIdioma(idiomaClave: string) {
        localStorage.setItem(this.localStoreVariable.Lenguaje, idiomaClave);
        window.location.reload();
    }

    SetIdiomas() {
        var idiomas: Array<string> = [];
        var idiomasDefault: string = "";

        var idiomaUsuario = localStorage.getItem(this.localStoreVariable.Lenguaje);
        var idiomaUsuarioActivo = false;

        this.idiomas.forEach(idioma => {
            idiomas.push(idioma.Clave);

            if (idioma.Defecto) {
                idiomasDefault = idioma.Clave;
            }

            if (idioma.Clave == idiomaUsuario) {
                idiomaUsuarioActivo = true;
            }
        });

        this.translate.addLangs(idiomas);
        this.translate.setDefaultLang(idiomasDefault);

        if (idiomaUsuario && idiomaUsuarioActivo) {
            this.translate.use(idiomaUsuario).subscribe(() => {
                this.SetIdiomaSeleccionado();
            });

            locale(idiomaUsuario);
        }
        else {
            locale(idiomasDefault);
            this.translate.use(idiomasDefault).subscribe(() => {
                this.SetIdiomaSeleccionado();
            });
        }
    }

    SetIdiomaSeleccionado() {
        this.idiomas.forEach((idioma: any) => {
            if (idioma.Clave == this.translate.currentLang) {
                this.idiomaSeleccionado = idioma;
            }
        });
    }

    // ------------- menú --------
    SetUsuarioMenu() {
        //  Uusario opciones  --------------------------
        this.opcionesMenu.push(new OpcionMenu(
            {
                Titulo: this.usuario.nombre,
                Icono: "assets/Icono/usuarioPerfil.svg",
                TipoIconoId: TipoIconoEnum.SvgLocal,
                TipoModulo: TipoOpcionMenuEnum.Modulo,
            }));

        this.opcionesMenu[this.opcionesMenu.length - 1].SubMenu.push(new OpcionMenu(
            {
                Titulo: this.translate.instant("Perfil.CambiarPassword"),
                Icono: "assets/Icono/cambiarPassword.svg",
                TipoIconoId: TipoIconoEnum.SvgLocal,
                Funcion: FuncionesUsuarioEnum.CambiarPassword,
                TipoModulo: TipoOpcionMenuEnum.Funcion,
            }
        ));

        this.opcionesMenu[this.opcionesMenu.length - 1].SubMenu.push(new OpcionMenu(
            {
                Titulo: this.translate.instant("Perfil.CerrarSesion"),
                Icono: "assets/Icono/logout.svg",
                TipoIconoId: TipoIconoEnum.SvgLocal,
                Funcion: FuncionesUsuarioEnum.CerrarSesion,
                TipoModulo: TipoOpcionMenuEnum.Funcion,
            }
        ));

        if (this.usuario.usuarioenmascarado) {
            this.opcionesMenu[this.opcionesMenu.length - 1].SubMenu.push(new OpcionMenu(
                {
                    Titulo: this.translate.instant("Perfil.CerrarSesionEnmascarado"),
                    Icono: "assets/Icono/cerrarEnmascarado.svg",
                    TipoIconoId: TipoIconoEnum.SvgLocal,
                    Funcion: FuncionesUsuarioEnum.CerrarSesionEnmascarado,
                    TipoModulo: TipoOpcionMenuEnum.Funcion,
                }
            ));
        }
    }

    GetMenuHome() {
        this.menuHome = [];

        this.menuHome = this.menuHome.concat(this.opcionesMenu.filter(p => p.PantallaInicio));

        this.opcionesMenu.forEach(opcion => {
            if (!opcion.SubMenu) {
                opcion.SubMenu = [];
            }

            if (opcion.SubMenu.length > 0) {
                this.menuHome = this.menuHome.concat(opcion.SubMenu.filter(p => p.PantallaInicio));

                opcion.SubMenu.forEach(submenu => {
                    if (!submenu.SubMenu) {
                        submenu.SubMenu = [];
                    }
                    if (submenu.SubMenu.length > 0) {
                        this.menuHome = this.menuHome.concat(submenu.SubMenu.filter(p => p.PantallaInicio));
                    }
                });
            }
        });

        this.menuHome.sort((a: OpcionMenu, b: OpcionMenu) => {
            if (a.OrdenInicio > b.OrdenInicio) {
                return 1;
            }
            else if (a.OrdenInicio < b.OrdenInicio) {
                return -1;
            }

            return 0;
        });
    }

    ActivarOpcionMenu(url: string) {
      url = url.split('?')[0];
        this.opcionesMenu.map(p => {
            if (p.Ruta == url) {
                p.Activo = true;

                this.pathActivo = p.Titulo;
                this.NombrePantallaActual = p.Titulo;
                this.pantallaid = p.PantallaId;
            }
            else {
                p.Activo = false;
            }

            p.SubMenu.forEach(p2 => {
                if (p2.Ruta == url) {
                    p2.Activo = true;
                    p.Activo = true;

                    this.pathActivo = p.Titulo + " > " + p2.Titulo;
                    this.NombrePantallaActual = p2.Titulo;
                    this.pantallaid = p2.PantallaId;
                }
                else {
                    p2.Activo = false;
                }

                p2.SubMenu.forEach(p3 => {
                    if (p3.Ruta == url) {
                        p3.Activo = true;
                        p2.Activo = true;
                        p.Activo = true;

                        this.pathActivo = p.Titulo + " > " + p2.Titulo + " > " + p3.Titulo;
                        this.NombrePantallaActual = p3.Titulo;
                        this.pantallaid = p3.PantallaId;
                    }
                    else {
                        p3.Activo = false;
                    }
                });
            });
        });


    }

    CambiarPaginacionTabla(evento: any) {
        if (evento.fullName == "paging.pageSize") {
            this.tablaPaginacion = evento.value;
            localStorage.setItem(this.localStoreVariable.Paginacion, evento.value);
        }
    }

    //---------- Fechas -------
    String2Date(date: any) {
        if (date) {
            return new Date(date.slice(0, 4), parseInt(date.slice(5, 7)) - 1, date.slice(8, 10));
        }
        else {
            return null;
        }
    }

    String2DateControl(date: any) {
        if (date) {
            let year = parseInt(date.slice(0, 4));
            let mes = parseInt(date.slice(5, 7)) - 1;
            let dia = parseInt(date.slice(8, 10));

            return {date: {year: year, month: mes + 1, day: dia}, jsdate: new Date(year, mes, dia)};
        }
        else {
            return null;
        }
    }

    Date2String(val: any) {
        if (val) {
            let mes = val.date.month;
            let dia = val.date.day;

            if (mes < 10) {
                mes = "0" + mes;
            }

            if (dia < 10) {
                dia = "0" + dia;
            }

            return val.date.year + "-" + mes + "-" + dia;
        }
        else {
            return null;
        }
    }

    Date2StringRange(val: any) {
        if (val) {
            let mes = val.month;
            let dia = val.day;

            if (mes < 10) {
                mes = "0" + mes;
            }

            if (dia < 10) {
                dia = "0" + dia;
            }

            return val.year + "-" + mes + "-" + dia;
        }
        else {
            return null;
        }
    }

    String2DateRange(date: any) {
        if (date) {
            let year = parseInt(date.slice(0, 4));
            let mes = parseInt(date.slice(5, 7));
            let dia = parseInt(date.slice(8, 10));

            return {year: year, month: mes, day: dia};
        }
        else {
            return {year: "", month: "", day: ""};
        }
    }

    String2DatePicker(date: any) {
        if (date) {
            var year = parseInt(date.slice(0, 4));
            var mes = parseInt(date.slice(5, 7)) - 1;
            var dia = parseInt(date.slice(8, 10));

            return {date: {year: year, month: mes + 1, day: dia}, jsdate: new Date(year, mes, dia)};
        }
        else {
            return null;
        }
    }

    Date2DateRange(date: any) {
        if (date) {
            let year = date.getFullYear();
            let mes = date.getMonth() + 1;
            let dia = date.getDate();

            return {year: year, month: mes, day: dia};
        }
        else {
            return null;
        }
    }

    EnglishDateToSpanishDate(fecha: string) {
        let day = fecha.slice(8, 10);
        let month = fecha.slice(5, 7);
        let year = fecha.slice(0, 4);

        return day + "-" + month + "-" + year;
    }

    SpanishDateToEnglisDate(fecha: string) {
        let year = fecha.slice(6, 10);
        let month = fecha.slice(3, 5);
        let day = fecha.slice(0, 2);

        return year + "-" + month + "-" + day;
    }

    GetHoyEng() {
        let fecha = new Date();
        let month = fecha.getMonth() + 1;
        let day = fecha.getDate();

        return fecha.getFullYear() + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day);
    }

    LimpiarDatosSesion() {
        localStorage.removeItem(this.localStoreVariable.AOT);
        localStorage.removeItem(this.localStoreVariable.JWT);
        localStorage.removeItem(this.localStoreVariable.SesionValida);
        this.permisosCargados = false;
        this.permisos = new PermisoPantalla();
        this.usuario = null;
        this.opcionesMenu = [];
    }

    //-----
    GetOpcionesSalir() {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: "Salir", Valor: 1}));
        opciones.push(new DialogoOpcion({Titulo: "Cancelar", Valor: 2, Tipo: TipoOpcionEnum.negativo}));

        return opciones;
    }

    GetOpcionesSalirEvaluacion(titulo:string = "Salir") {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: titulo, Valor: 1}));

        return opciones;
    }

    GetOpcionesEliminar() {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: "Eliminar", Valor: 1}));
        opciones.push(new DialogoOpcion({Titulo: "Cancelar", Valor: 2, Tipo: TipoOpcionEnum.negativo}));

        return opciones;
    }

    GetOpcionesAceptar() {
      let opciones = [];

      opciones.push(new DialogoOpcion({Titulo: "Aceptar", Valor: 1}));
      opciones.push(new DialogoOpcion({Titulo: "Cancelar", Valor: 2, Tipo: TipoOpcionEnum.negativo}));

      return opciones;
  }

    GetOpcionesConfirmar() {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: "Sí", Valor: 1}));
        opciones.push(new DialogoOpcion({Titulo: "Cancelar", Valor: 2, Tipo: TipoOpcionEnum.negativo}));

        return opciones;
    }

    RemoveAcentos(str: string): string {
        var accents = 'àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ';
        var reAccents = new RegExp('[' + accents + ']', 'g');
        var replacements = 'aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY';
        return str.replace(
            reAccents,
            function (match) {
                return replacements[accents.indexOf(match)];
            }
        );
    };

    // borrar elemento arreglo
    BorrarElemento(lista: Array<any>, elemento: any, propiedad: string) {
        for (let k = 0; k < lista.length; k++) {

            if (lista[k][propiedad] == elemento[propiedad]) {
                lista.splice(k, 1);
                break;
            }
        }
    }

    BorrarElementoValor(lista: Array<any>, elemento: any, propiedad: string) {
        for (let k = 0; k < lista.length; k++) {
            if (lista[k][propiedad] == elemento) {
                lista.splice(k, 1);
                break;
            }
        }
    }

    BorrarElementoValorPorValor(lista: Array<any>, elemento: any) {
        for (let k = 0; k < lista.length; k++) {
            if (lista[k] == elemento) {
                lista.splice(k, 1);
                break;
            }
        }
    }

    GetEntidadPorId(entidaddes: any, id: any, atributo: string) {
        for (let k = 0; k < entidaddes.length; k++) {
            if (entidaddes[k][atributo] == id) {
                return entidaddes[k];
            }
        }

        return null;
    }

    GetRelacionados(id: any, lista: Array<any>, atributo: string) {
        return lista.filter(p => {
            return p[atributo] == id;
        });
    }

    GetValorParametro(clave: string) {
        for (let parametro of this.parametros) {
            if (parametro.nombre == clave) {
                return parametro.Valor;
            }
        }

        return null;
    }

    GetNombreUsuario(persona: any) {
        return persona.Nombre + (persona.PrimerApellido ? (" " + persona.PrimerApellido) : '') + (persona.SegundoApellido ? (" " + persona.SegundoApellido) : '');
    }

    Calcularporcentage(valor: number, total: number) {
        let porcentage = Math.round((valor * 10000.00) / total);

        return (porcentage / 100).toFixed(2);
    }

    GetValorActivo(dato: any) {
        if (dato.activo) {
            return this.translate.instant("Si");
        }
        else {
            return this.translate.instant("No");
        }
    }

    GetValorOrden(dato: any) {
        return dato.orden ? dato.orden : "-";
    }

    GetFechaValor(dato: any, parametro: string) {
        return this.datePipe.transform(dato[parametro], this.translate.instant("FormatoFechaHora"));
    }


    TieneValor(valor: any): boolean {
        if (valor || valor === 0 || valor === false) {
            return true;
        }
        else {
            return false;
        }
    }

    TieneValorArreglo(valor: any): boolean {
        if (valor && valor.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    TimePickerToString(time: any) {
        if (!time) {
            return null;
        }

        let hour = time.hour.toString().padStart(2, "0");
        let minute = time.minute.toString().padStart(2, "0");
        let second = time.second.toString().padStart(2, "0");

        return hour + ":" + minute + ":" + second;
    }

    String2TimePicker(time: any) {
        if (time) {
            var hour = parseInt(time.slice(0, 2));
            var minute = parseInt(time.slice(3, 5));
            var second = parseInt(time.slice(6, 8));

            return {hour: hour, minute: minute, second: second};
        }
        else {
            return null;
        }
    }

    AbrirPanelFixed()
  {
    this.body.classList.add('freezePage');
    this.html.classList.add('freezePage');
  }

  CerrarPanelFixed()
  {
    this.body.classList.remove('freezePage');
    this.html.classList.remove('freezePage');
  }

    AbrirPanelInteriorFixed()
  {
    this.AbrirPanelFixed();

    let sidebar = document.getElementById('sidebarApp');
    let header: HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar!.classList.add('panelFondo');
    header!.classList.add('panelFondo');
  }

  CerrarPanelInteriorFixed()
  {
    this.CerrarPanelFixed();

    let sidebar = document.getElementById('sidebarApp');
    let header: HTMLElement = document.getElementById('encabezadoApp')!;

    sidebar!.classList.remove('panelFondo');
    header!.classList.remove('panelFondo');
  }

}
